<template>
  <!-- Device groups -->
  <TriggerComponentDeviceGroups class="pa-0" :deviceGroupsChosen="deviceGroupsChosen"/>
  <!-- Model Path Matcher -->
  <TriggerComponentModelPathMatcher class="pa-0" :policy="policy" />
  <!-- Match interval -->
   <v-row class="my-0 pt-4 pb-0">
    <v-col cols="3" class="py-1 pr-0">{{ $t("matchInterval") }}: </v-col>
    <v-col cols="9" class="py-1 pr-0">
      <div class="radio-container mx-4" @click="togglePolicyMatch(true)">
        <v-icon 
          :color="policy.inside == true ? 'var(--color-highlight)' : 'var(--color-g4)'"
          style="font-size:22px">{{policy.inside == true  ? 'ecc:ecc-E-RadioON' : 'ecc:ecc-E-RadioOFF'}}</v-icon>
        <div class="radio-text">{{ $t('inside') }}</div>
      </div>
      <div class="radio-container" @click="togglePolicyMatch(false)">
        <v-icon 
          :color="policy.inside == false ? 'var(--color-highlight)' : 'var(--color-g4)'"
          style="font-size:22px">{{policy.inside == false ? 'ecc:ecc-E-RadioON' : 'ecc:ecc-E-RadioOFF'}}</v-icon>
        <div class="radio-text">{{ $t('outside') }}</div>
      </div>
    </v-col>
  </v-row>
  <!-- min max -->
  <v-row class="my-1">
    <v-col class="py-0">
      <v-row class="pa-0 ma-0">
        <v-btn :class="{ 'btn-base': true, 'btn-left': true, 'btn-active': !policy.minOrEqual, 'btn-unactive': policy.minOrEqual }" @click="setMinOrEqual(false)" tile variant="plain">></v-btn>
        <v-btn :class="{ 'btn-base': true, 'btn-right': true, 'btn-active': policy.minOrEqual, 'btn-unactive': !policy.minOrEqual }" @click="setMinOrEqual(true)" tile variant="plain">≥</v-btn>
        <v-text-field v-model="policy.min" type="number" :label="$t('min')" class="half pr-2 pl-4" data-qa="prop-control-grid-cols" hide-details> </v-text-field>
      </v-row>
      <v-row class="pa-0 ma-0">
        <v-btn :class="{ 'btn-base': true, 'btn-left': true, 'btn-active': !policy.maxOrEqual, 'btn-unactive': policy.maxOrEqual }" @click="setMaxOrEqual(false)" tile variant="plain"><</v-btn>
        <v-btn :class="{ 'btn-base': true, 'btn-right': true, 'btn-active': policy.maxOrEqual, 'btn-unactive': !policy.maxOrEqual }" @click="setMaxOrEqual(true)" tile variant="plain">≤</v-btn>
        <v-text-field v-model="policy.max" type="number" :label="$t('max')" class="half pr-2 pl-4" data-qa="prop-control-grid-cols" hide-details> </v-text-field>
      </v-row>
      <v-row class="pa-0 ma-0" v-if="Number(policy.min) > Number(policy.max)">
        <div style="color: var(--color-alert);">{{ $t("minGreaterMax") }}</div>
      </v-row>
    </v-col>
  </v-row>
  <!-- time -->
  <v-row class="my-1">
    <v-col class="py-0">
      <v-text-field
        v-model="policy.time"
        type="number"
        :min="0"
        :step="0"
        :label="$t('time')"
        data-qa="prop-control-grid-time"
        hide-details>
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TriggerComponentModelPathMatcher from "./TriggerComponentModelPathMatcher.vue";
import TriggerComponentDeviceGroups from "./TriggerComponentDeviceGroups.vue";
import { TriggerPolicyAnalogBand } from "./type.util";

export default defineComponent({
  name: "TriggerPolicyAnalogBandComponent",
  components: {
    TriggerComponentModelPathMatcher,
    TriggerComponentDeviceGroups,
  },
  props: {
    policy: {
      type: Object as () => TriggerPolicyAnalogBand,
      default: null,
    },
    deviceGroupsChosen: {
      type: Array,
      default: [],
    },
  },
  methods: {
    setMinOrEqual(value: boolean): void {
      this.policy.minOrEqual = value;
    },
    setMaxOrEqual(value: boolean): void {
      this.policy.maxOrEqual = value;
    },
    togglePolicyMatch(value: boolean): void {
      this.policy.inside = value;
    },
  }
});
</script>

<style scoped>
.header {
  font-weight: bold;
}
.radio-container {
  display: inline-flex;
  cursor: pointer;
}

.radio-text{
  margin: auto;
}
.radio-label {
  color: var(--color-g4);
}
.half {
  width: 50%;
}
.v-theme--light.v-btn.btn-base {
  font-size: 20px;
  font-weight: normal;
  min-height: 42px;
  padding: 0;
  letter-spacing: normal;
}
.v-theme--light.v-btn.btn-active {
  background: var(--color-g2);
}
.v-theme--light.v-btn.btn-unactive {
  background: var(--color-g1);
}
.btn-left {
  border-bottom-left-radius: 5px !important;
  border-top-left-radius: 5px !important;
}
.btn-right {
  border-bottom-right-radius: 5px !important;
  border-top-right-radius: 5px !important;
}
</style>
